@if (team(); as t) {
	<div class="drawer-content bg-surface pt-2" [class.is-open]="isOpen()">
		<div class="drawer-inner bg-surface-container">
			<div class="drawer-meta">
				<span class="drawer-meta-strong">{{ t.team || 'Unknown Team' }}</span>
				<span class="drawer-meta-separator">|</span>
				<span>{{ t.manufacturer || t.vehicle || 'Unknown Vehicle' }}</span>

				@if (t.drivers?.[t.currentDriver]?.country) {
					<span class="drawer-meta-separator">|</span>
					<span>Country: {{ t.drivers[t.currentDriver].country }}</span>
				}
				<div class="flex grow-1 gap-2">
					<div class="drawer-stat-item">
						<span class="drawer-stat-value">{{
							t.participantDetails?.bestLap?.time | timespanMs
						}}</span>
						<span class="drawer-stat-label">BEST LAP</span>
					</div>
					<div class="drawer-stat-item">
						<span class="drawer-stat-value">
							@if (t.participantDetails?.avgSpeed != null) {
								{{ t.participantDetails.avgSpeed * 0.621371 | number: '1.1-1' }} mph
							} @else if (t.participantDetails?.bestTopSpeed != null) {
								{{ t.participantDetails.bestTopSpeed * 0.621371 | number: '1.1-1' }} mph
							} @else {
								-
							}
						</span>
						<span class="drawer-stat-label">AVG SPEED</span>
					</div>
					<div class="drawer-stat-item">
						@if (getBestSector(t); as bestSector) {
							<span class="drawer-stat-value"
								>S{{ bestSector.number }} {{ bestSector.time | timespanShort }}</span
							>
						} @else {
							<span class="drawer-stat-value">--</span>
						}
						<span class="drawer-stat-label">BEST SECTOR</span>
					</div>
					<div class="drawer-stat-item">
						<span class="drawer-stat-value">{{ t.participantDetails?.pitStops ?? 0 }}</span>
						<span class="drawer-stat-label">PITS</span>
					</div>
				</div>
			</div>

			<div class="drawer-stats">
				@if (visibilitiesService.controlVisibilities().showTelemetry && telemetry()) {
					<div class="drawer-stat-item justify-end">
						<div class="drawer-stat-value flex flex-row gap-6">
							<vb-lxp-bar-gauge
								label="BRK"
								[value]="telemetry()?.brake_percentage_front"
								color="#ff0000"
								direction="right"
								unit="%"
							></vb-lxp-bar-gauge>
							<vb-lxp-bar-gauge
								label="THR"
								[value]="telemetry()?.throttle_percentage"
								color="#00ff00"
								direction="right"
								unit="%"
							></vb-lxp-bar-gauge>
							<vb-lxp-bar-gauge
								label="BAT"
								[value]="telemetry()?.energy_remaining"
								color="#ffff00"
								direction="right"
								unit="%"
							></vb-lxp-bar-gauge>
							<span
								>Charge Status:
								{{ telemetry()?.is_recharging ? 'Charging' : 'Discharging' }}
							</span>
						</div>
					</div>
					<div class="drawer-stat-item flex flex-row! justify-between">
						<div class="flex flex-col">
							<div class="grow-1"></div>
							<strong class="text-on-surface text-xl">
								{{ formatSpeed(telemetry()?.speed) }}
							</strong>
							<div class="grow-1"></div>
							<span class="drawer-stat-label">Speed</span>
						</div>
						<div class="flex flex-col">
							<div class="grow-1"></div>
							<strong class="text-on-surface text-xl">
								{{ telemetry()?.gear }}
							</strong>
							<div class="grow-1"></div>
							<span class="drawer-stat-label">gear</span>
						</div>
						<div class="flex flex-col">
							<div class="grow-1"></div>
							<strong class="text-on-surface text-xl">
								{{ formatRpm(telemetry()?.engine_rpm) }}
							</strong>
							<div class="grow-1"></div>
							<span class="drawer-stat-label">rpm</span>
						</div>
					</div>
				}
				<!-- TODO: Fix later; Commented out to fix performance issues
				<div class="drawer-stat-item col-span-4">
					<lib-lap-time-chart
						class="h-80"
						[participantNumber]="team().participantDetails.participant"
					></lib-lap-time-chart>
				</div>
					-->
			</div>
		</div>
	</div>
}
